var portfolioList = {
	label: {
		caption: "Lista di Portafoglio",
		name: "Portafoglio",
		currency: "Valuta",
		numberOfPositions: "Posizioni",
		numberOfTransactions: "Transazioni",
		actions: "Azioni"
	},
	noPortfolios: {
		title: "Info",
		message: "No portfolio has been created yet. Please click on the \"Add portfolio\" button and fill out the form to create a portfolio."
	},
	error: {
		title: "Si è verificato un errore.",
		portfolioLimitExceeded: "Limite di portafoglio superato."
	},
	createPortfolioAction: "Crea portafoglio",
	editPortfolioAction: "Modifica portafoglio",
	deletePortfolioAction: "Elimina portafoglio",
	showActions: "Mostra azioni"
};
var it = {
	portfolioList: portfolioList
};

export { it as default, portfolioList };
